import { debounce, throttle } from "./debounceThrottle";
import permission from "./permission";

export default {
  debounce,
  throttle,
  permission,
};
